export default __webpack_public_path__ + "static/media/oi_6.ac561fc8.mp3";